/**
 * @description：request result enum
 */
export enum ResultEnum {
  /** success */
  SUCCESS = '200',
  /** failure */
  ERROR = '500',
  /** login expired */
  OVERDUE = '401'
}

/**
 * @description：theme enum
 */
export enum ThemeEnum {
  /** default */
  DEFAULT = 'default',
  /** garrett */
  GARRETT = 'garrett',
  /** dark */
  DARK = 'dark',
  /** light */
  LIGHT = 'light'
}

/**
 * @description：language enum
 */
export enum LanguageEnum {
  /** English */
  EN = 'en',
  /** Chinese */
  ZH_CN = 'zh-cn'
}

/**
 * @description：auth mode enum
 */
export enum AuthModeEnum {
  /** oauth2 */
  OAUTH2 = 'oauth2',
  /** local */
  LOCAL = 'local'
}

/**
 * @description：sort order enum
 */
export enum SortOrderEnum {
  /** ascending */
  ASC = 'asc',
  /** descending */
  DESC = 'desc'
}

/**
 * @description：model operation enum
 */
export enum ModelOperation {
  /** create */
  CREATE = 'create',
  /** update */
  UPDATE = 'update'
}

/**
 * Menu row / navigation: in-app route vs external URL.
 */
export enum MenuItemTypeEnum {
  NORMAL = 'NORMAL',
  LINK = 'LINK'
}
